import React, { useState, useEffect } from "react";
import SearchDropDown from "../SearchDropDown";

const EmailSearchBlock = (props) => {
  const [allEmails, setAllEmails] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [searchBarFocus, setSearchBarFocus] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (props.usersList) {
      setAllEmails(
        props.usersList
          .sort((a, b) => a.userDomainName.localeCompare(b.userDomainName))
          .map((user) => user.userDomainName)
      );
    }
  }, [props.usersList]);

  useEffect(() => {
    setFilteredEmails(
      allEmails
        .sort((a, b) => a.localeCompare(b))
        .filter((user) => user.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  }, [searchQuery, allEmails]);

  const onSearchBarBlur = () => {
    setSearchBarFocus(false);
    if (!allEmails.includes(searchQuery)) {
      setSearchQuery("");
    }
  };

  const onSearchBarFocus = () => {
    setSearchBarFocus(true);
    setFilteredEmails(allEmails);
  };

  const onEmailMouseDown = (email) => {
    setSearchQuery(email);
    props.setUserToRemove((prevUserToRemove) => ({
      ...prevUserToRemove,
      emailRecipient: email,
    }));
  };

  return (
    <div>
      Forward email to
      <SearchDropDown
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearchBarFocus={onSearchBarFocus}
        onSearchBarBlur={onSearchBarBlur}
        searchBarFocus={searchBarFocus}
        allInfo={allEmails}
        filteredInfo={filteredEmails}
        onInfoMouseDown={onEmailMouseDown}
        height="200px"
      />
    </div>
  );
};

export default EmailSearchBlock;
